import { render, staticRenderFns } from "./BaseNavLayout.vue?vue&type=template&id=56ad1f2b&scoped=true&"
import script from "./BaseNavLayout.vue?vue&type=script&lang=js&"
export * from "./BaseNavLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavLayout.vue?vue&type=style&index=0&id=56ad1f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ad1f2b",
  null
  
)

export default component.exports